module.exports = __webpack_public_path__ + "static/media/bg_03.6b49d71c.png";